<template>
  <div class="product-container-component">
    <div class="product-container" @mouseover="isActive = true" @mouseleave="isActive = false">
      <div class="product-image box" :style="backgroundImage(product.image)">
        <div class="product-image-overlay" v-show="isActive">
          <strong v-show="isActive">
            <a class="btn btn-link font-weight-bold details d-block d-lg-none" :href="`/product/${product.slug}`">
              See full details
              <i class="fa fa-arrow-right"></i>
            </a>
            <a class="btn btn-link font-weight-bold d-none d-lg-block" v-b-modal.product-preview @click="getProductSlug(product.slug)">
              See full details
              <i class="fa fa-arrow-right"></i>
            </a>
          </strong>
        </div>
      </div>
      <div class="product-name">
        <strong>{{ product.name | shorten }}</strong>
        <div class="mt-2">Php {{ product.price }}</div>
        <div class="rating mt-2">
          <p v-if="product.rating === 0">No rating yet</p>
          <img v-for="(rating, index) in product.rating" :key="index" class="choco-rating" src="../../assets/images/store/choco-rating.png" height="20">
          <img v-show="product.rating > 0" v-for="(rating, index) in (5 - product.rating)" :key="index + 10" class="choco-rating" src="../../assets/images/store/no-choco-rating.png" height="20">
        </div>
      </div>
      <div class="mt-2" v-show="isActive">
        <a :href="product.lazada_url" target="_blank" class="btn btn-block btn-dutche-orange d-none d-lg-block">
          <strong>Shop from lazada</strong>
        </a>
        <a :href="product.shopee_url" target="_blank" class="btn btn-block btn-dutche-orange d-none d-lg-block">
          <strong>Shop from shopee</strong>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ProductContainer",
  components: {
  },
  props: {
    product: Object,
    active: Boolean,
  },
  data() {
    return {
      isActive: false
    }
  },
  mounted() {
    this.isActive = this.active
  },
  methods: {
    backgroundImage(imageUrl) {
      return { backgroundImage: `url(${imageUrl})` };
    },
    getProductSlug(slug) {
      this.$emit('get-product-slug', slug);
    }
  },
  filters: {
    shorten(productName) {
      if (productName.length > 20) {
        return `${productName.substring(0, 20)}...`;
      }

      return productName;
    }
  }
};
</script>

<style lang="sass" scoped>
.product-container
  height: 450px
  margin-top: 3rem

  .product-image
    background-position: center !important
    background-size: cover !important
    a:visited
      color: $white
      text-decoration: none
    a:hover,
    a:focus
      color: $dutche-primary-yellow
      text-decoration: none

  .product-name
    min-height: 50px
    height: 7rem
    background-color: $dutche-primary-violet
    padding: 1rem
    color: $white
    font-size: 0.8em

  .product-image
    position: relative
    .product-image-overlay
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      text-align: center
      padding-top: 50%
      text-transform: uppercase

  .product-image a,
  .product-image a:active,
  .product-image a:visited
    color: $dutche-primary-brown
    text-decoration: none
  .product-image a:hover,
  .product-image a:focus
    color: $dutche-primary-violet
    text-decoration: none
  .product-container:hover,
  .product-name:hover
    background-color: $dutche-primary-yellow

  .product-image-overlay
    background-color: $dutche-quaternary-yellow

  .choco-rating
    padding-right: 0.2rem

  .details
    font-size: 0.8rem

.box
  padding-bottom: 100%

.btn-dutche-orange
  text-transform: uppercase
  border-radius: 0.5rem
  background-color: $dutche-primary-orange
  color: $white
  font-size: 0.8em

@media(min-width: 992px)
  .product-container
    .product-name
      font-size: 1em
      height: 8rem

  .btn-dutche-orange
    font-size: 1em

@media(max-width: 991px)
  .product-container
    height: auto
    
</style>
